import { styled } from "@mui/material";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
const BlockNoticeIconContainer = styled("div")({
  display: Displaying.flex,
  alignItems: Alignment.center
});
export {
  BlockNoticeIconContainer
};
//# sourceMappingURL=block-notice-icon-container.es.js.map
